/**
 * Who may open Issue Triage: Owner / Admin / Developer, plus two NAMED people by login (Nick,
 * 2026-10-05; both are Managers, and the page must not open to every Manager).
 *
 * Twin of functions/src/issueTriage/config/issueOwners.ts (ISSUE_TRIAGE_EXTRA_LOGINS) and of
 * firestore.rules isIssueTriageUser(); a jest parity test in functions pins all three lists.
 * This is only the route/nav gate: the server and the rules are the real enforcement.
 */
const TRIAGE_ROLES: readonly string[] = ['Owner', 'Admin', 'Developer'];
const TRIAGE_EXTRA_LOGINS: readonly string[] = ['jcampo@onpointgen.com', 'jrendina@onpointgen.com'];

export function canAccessIssueTriage(user: { role?: unknown; email?: string | null } | null | undefined): boolean {
  if (!user) return false;
  if (typeof user.role === 'string' && TRIAGE_ROLES.includes(user.role)) return true;
  return !!user.email && TRIAGE_EXTRA_LOGINS.includes(user.email.trim().toLowerCase());
}
